import { Button } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../../util/Configuracao';
import AutoComplete from '../AutoComplete';
import ReactComponent from '../ReactComponent';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';

class VistaEmMesa extends ReactComponent {
    magistradoSelecionado;
    executandoAcao = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            magistradoSelecionado: observable,
            executandoAcao: observable,
            magistrados: computed,
            magistradosFiltrados: computed,
            registro: computed,
            handleConfirmar: action,
            excluirMagistradoVistaMesa: action,
            callbackAutoCompleteMagistradoVista: action
        });
    }

    get magistrados() {
        if (this.registro.processo.origem === Configuracao.ORIGEM_PJE) {
            return this.dominioStore.opcoesMagistradosComposicao(this.registro);
        }
        return this.dominioStore.opcoesMagistradosAutoComplete(this.registro);
    }

    get magistradosFiltrados() {
        return this.magistrados.filter(
            (magistrado) => magistrado.sigla !== (this.magistradoSelecionado ? this.magistradoSelecionado.sigla : '')
        );
    }

    get registro() {
        return this.observableProps.registro;
    }

    handleConfirmar = async () => {
        if (this.magistradoSelecionado) {
            this.executandoAcao = true;
            try {
                await this.sessaoService.registrarVistaMesa(
                    this.registro.sessaoId,
                    this.registro.processo.numeroCompleto,
                    [this.magistradoSelecionado],
                    this.sessaoStore.clienteEnvelopeId
                );
                runInAction(
                    () => (this.registro.informacaoProcessoSalaSessao.magistradoVistaEmMesa = this.magistradoSelecionado)
                );
                this.sessaoStore.atualizarListaProcessos();
                this.observableProps.fechar();
                this.mensagemStore.abrirMensagemSucesso('Pedido de vista em mesa realizado com sucesso.');
            } finally {
                runInAction(() => {
                    this.executandoAcao = false;
                });
            }
        } else {
            this.mensagemStore.abrirMensagemAlerta('Selecione um magistrado');
        }
    };

    handleClickCancelar = () => {
        this.observableProps.fechar();
    };

    excluirMagistradoVistaMesa = () => {
        this.magistradoSelecionado = undefined;
    };

    callbackAutoCompleteMagistradoVista = (option) => {
        this.magistradoSelecionado = option ? option.valor : null;
    };

    render() {
        return (
            <div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '10px 10px 10px 10px',
                        minWidth: '350px',
                        maxWidth: '600px'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: '40px',
                            paddingTop: '20px',
                            fontWeight: 'bold',
                            fontSize: '14pt',
                            justifyContent: 'center',
                            marginLeft: '20px',
                            marginRight: '20px'
                        }}
                    >
                        Vista em Mesa do Processo {this.registro.processo.numeroCompleto}
                    </div>
                    <div style={{ marginLeft: '20px', marginRight: '25px' }}>
                        <AutoComplete
                            apresentarTextoSecundario
                            value={this.magistradoSelecionado ? this.magistradoSelecionado.sigla : null}
                            options={this.magistradosFiltrados}
                            onChange={this.callbackAutoCompleteMagistradoVista}
                            label="Selecione..."
                        />
                    </div>
                </div>
                <div
                    style={{
                        marginBottom: '10px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginRight: '25px'
                    }}
                >
                    <Button
                        onClick={this.handleClickCancelar}
                        color="secondary"
                        variant="outlined"
                        sx={{ mr: 2 }}
                        endIcon={<CancelIcon />}
                    >
                        Cancelar
                    </Button>
                    <Button
                        color="primary"
                        variant="outlined"
                        endIcon={<AddCircleIcon />}
                        onClick={this.handleConfirmar}
                        disabled={this.executandoAcao}
                        loading={this.executandoAcao}
                    >
                        Incluir
                    </Button>
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(VistaEmMesa));
